/**
* LoginFormMdule is a reusable Module to use the login module features
 */

// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Modules
// Own Components
import { MultiSelectFieldComponent } from 'libraries/module/formbuilder/fields/multiselect-field/multiselect-field.component';
import { MultiComboboxModule } from '../multi-combobox/multi-combobox.module';

/**
 * @deprecated
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MultiComboboxModule
    ],
    declarations: [
        MultiSelectFieldComponent
    ],
    exports: [
        MultiSelectFieldComponent
    ]
})

export class MultiSelectFieldModule { }
